import { useContext } from "react";
import { HttpContext } from "./HttpContext";

export const useHttp = () => {
  const context = useContext(HttpContext);

  if (!context) {
    throw new Error("useHttp must be used inside HttpProvider");
  }

  return context;
};
